import type React from 'react';
import {Tooltip} from '@mui/material';
import {Tag} from '~/components/tag/Tag';

type Props = {score: number; reasons?: string[]};

/** A 0-100 score on the one ramp (80 / 60 / 30), with what lowered it in the tooltip. */
export const ConfidenceBadge: React.FC<Props> = ({score, reasons = []}) => {
    const color = score >= 80 ? 'success' : score >= 60 ? 'info' : score >= 30 ? 'warning' : 'error';
    const label = String(Math.round(score));
    const tag = <Tag size="small" label={label} color={color} aria-label={`Confidence ${label} out of 100`}/>;
    return reasons.length ? <Tooltip title={reasons.join(' · ')}>{tag}</Tooltip> : tag;
};
